module.exports = __webpack_public_path__ + "img/IMG_0184.b99ebba0.jpg";